import request from "@/utils/request";
// 获取Token
export function GetLoginToken(params) {
  return request({
    url: "/h5/Login/getLoginToken",
    method: "post",
    params,
    no_close_loading: true,
  });
}
// 刷新Token
export function RefreshToken(params) {
  return request({
    url: "/h5/index/refreshToken",
    method: "post",
    params,
  });
}
// 获取jssdk信息接口
export function GetJsSignPack(params) {
  return request({
    url: "/h5/login/getJsSignPack",
    method: "post",
    params,
  });
}
// 图文消息访问记录
export function InNewsRecord(params) {
  return request({
    url: "/h5/pageRecord/inNewsRecord",
    method: "post",
    params,
  });
}
// 更新用户信息
export function updateUserInfo(params) {
  return request({
    url: "/h5/login/updateUserInfo",
    method: "post",
    show_loading: false,
    params,
  })
}
// PVUV访问记录
export function inH5Record(params) {
  return request({
    url: "/h5/PageRecord/inH5Record",
    method: "post",
    show_loading: false,
    params,
  })
}

// 小程序授权登录
export function getSappLoginToken(params) {
  return request({
    url: '/h5/Login/getSappLoginToken',
    method: "post",
    params,
  })
}

// 小程序底部菜单-客户消息、预警未读消息数
export function getSappMenuInfo(params) {
  return request({
    url: '/h5/CommonParameter/getSappMenuInfo',
    show_loading: false,
    method: "post",
    params,
  })
}

// 缺省页判断接口
export function getAccountInfo(params) {
  return request({
    url: '/h5/CommonParameter/getAccountInfo',
    show_loading: false,
    method: "post",
    params,
  })
}

// '立即续费'弹窗判断
export function renew(params) {
  return request({
    url: '/h5/Coupon/renew',
    method: "post",
    params,
  })
}
// 获取旺旺昵称接口
export function getBuyerNick(params) {
  return request({
    url: '/h5/CommonParameter/getBuyerNick',
    method: "post",
    params,
  })
}
